var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwappiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_895_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_1257_152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5758 0H0V24H21.5758V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_895_682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.14295 24C8.99668 24 8.8504 23.9939 8.70413 23.9879C5.1418 23.8212 2.00349 21.6294 0.666585 18.3742C-0.670354 15.1191 0.0384036 11.3957 2.48177 8.838C3.29765 7.9943 3.72519 6.85739 3.66407 5.694C3.65798 5.598 3.65798 5.496 3.65798 5.4C3.65822 2.41779 6.11377 0 9.14295 0H9.3075C12.2902 0.122273 14.6406 2.54497 14.6279 5.484C14.6289 5.53209 14.6269 5.58018 14.6218 5.628C14.5796 6.84476 15.0314 8.02791 15.8773 8.916C17.4274 10.5743 18.2868 12.7463 18.2845 15C18.2827 19.9698 14.1909 23.9982 9.14295 24Z",
    fill: "#B7EA64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3892 6.92459C10.1533 7.92226 9.51331 8.78292 8.61631 9.30859C7.27776 10.0929 6.20086 11.2417 5.51683 12.615C5.48283 12.7003 5.44922 12.784 5.41613 12.8663C5.06267 13.7464 4.77001 14.475 4.7078 15.3919C4.64007 16.3906 4.85795 17.5893 5.11946 18.5331C6.2107 21.8455 9.38807 24.0658 12.9397 23.9982C16.4914 23.9307 19.5783 21.591 20.5373 18.2396C21.091 16.3333 20.8904 14.2926 19.9749 12.5252C19.4725 11.5763 19.3779 10.47 19.7122 9.45235C19.7301 9.41374 19.7443 9.37365 19.7549 9.33253C20.4825 6.84992 19.0752 4.24813 16.5698 3.44444C15.3213 3.05729 13.9659 3.18289 12.8137 3.79256C11.6614 4.40223 10.8108 5.44377 10.4564 6.67901C10.4519 6.69438 10.4475 6.70956 10.443 6.72459C10.4232 6.79162 10.4042 6.8561 10.3892 6.92459ZM16.0116 5.20468C17.5611 5.70656 18.3964 7.27965 17.9934 8.76038L17.9867 8.77486L17.9529 8.87759C17.463 10.369 17.6012 11.9901 18.3335 13.3787C19.0291 14.7259 19.1802 16.277 18.7593 17.7259L18.7573 17.7329C18.0266 20.2861 15.6612 22.1 12.9044 22.1525C10.162 22.2046 7.73628 20.5003 6.89171 17.9975C6.66049 17.1498 6.50819 16.2029 6.55477 15.5166C6.59652 14.9008 6.78161 14.4374 7.16619 13.4746C7.17946 13.4413 7.19298 13.4074 7.20677 13.373C7.73061 12.3519 8.54313 11.4927 9.55407 10.9003C10.8808 10.1228 11.8375 8.84329 12.191 7.34823L12.1945 7.33313L12.1971 7.32147C12.1976 7.31929 12.1991 7.31383 12.2019 7.30407L12.2141 7.26192L12.234 7.19453L12.2362 7.1868C12.4502 6.44077 12.9671 5.80123 13.6813 5.42341C14.3939 5.04638 15.2354 4.9665 16.0116 5.20468Z",
    fill: "#22454B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6072 16.3726C16.6072 18.4294 14.9358 20.0967 12.8741 20.0967C12.4222 20.098 11.9741 20.0144 11.5532 19.8503C9.86714 19.2152 8.87753 17.4682 9.20189 15.6997C9.52629 13.9312 11.0719 12.6471 12.8741 12.6485C13.1724 12.6466 13.4697 12.6832 13.7586 12.7574C15.4308 13.1621 16.608 14.6561 16.6072 16.3726Z",
    fill: "#6D4D42"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwappiIcon);
export default __webpack_public_path__ + "static/media/swappiIcon.a1290a020d5fa09271dc2d7850fbc64a.svg";
export { ForwardRef as ReactComponent };